module.exports = __webpack_public_path__ + "img/fileView.568b2afc.gif";